import { useMemo } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/ui/button";
import { SpokenMemoryBrowserPage } from "@/components/spoken-memory/SpokenMemoryBrowser";
import { createSpokenMemoryApi } from "@/data/spoken-memory";

interface BrowseScreenProps {
  workspaceSlug: string;
  source: string;
  onBack: () => void;
}

// Surfaces kept outside the primary nav render inside this minimal frame.
export function BrowseScreen({
  workspaceSlug,
  source,
  onBack,
}: BrowseScreenProps) {
  const spokenMemoryApi = useMemo(
    () => createSpokenMemoryApi({ workspaceSlug }),
    [workspaceSlug],
  );

  return (
    <div className="mx-auto flex max-w-[1100px] flex-col p-6">
      <div className="mb-4 flex items-center gap-3">
        <Button variant="outline" size="sm" className="h-7" onClick={onBack}>
          <ArrowLeft className="h-3 w-3" />
          Settings
        </Button>
        <div className="text-[12px] tracking-wider text-muted-foreground uppercase">
          Browse · {source}
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card text-foreground">
        {source === "spoken-memory" || source === "voice-profiles" ? (
          <SpokenMemoryBrowserPage
            api={spokenMemoryApi}
            workspaceSlug={workspaceSlug}
            onClose={onBack}
          />
        ) : (
          <div className="p-9 text-[14px] text-muted-foreground">
            Unknown source: {source}
          </div>
        )}
      </div>
    </div>
  );
}
